import styled from "styled-components";

export const StyledExperience = styled.section`
  background-color: ${({ theme }) => theme.backgroundColor.darkGray};
  color: ${({ theme }) => theme.color.darkGray};
`;

export const ExperienceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  margin-top: 3rem;
`;
